<template>
  <div class="all">
    <img class="img" style="width: 100%;position: relative;" src="../assets/new_home/phone.png" alt="">
    <!-- <img @click="addBtn" style="width: 30%;position: absolute;top: 7.5%;left: 7%;" src="../assets/new_home/apply_huo.png" alt=""> -->
    <img @click="han" style="width: 20%;position: absolute;bottom: 25.5%;left: 10%;" src="../assets/new_home/phon_apply.png" alt="">
    <img @click="han" style="width: 20%;position: absolute;bottom: 25.5%;left: 40%;" src="../assets/new_home/phon_apply.png" alt="">
    <img @click="han" style="width: 20%;position: absolute;bottom: 25.5%;left: 68%;" src="../assets/new_home/phon_apply.png" alt="">
    <div @click="wei" style="width: 100%;height: 43px;position: absolute;bottom: 0%;"></div>
    <div class="apply">
      <el-dialog :visible.sync="apply" width="80%" :show-close="false" :close-on-click-modal="false" top="25vh">
        <img
          style="width: 16%;height: 13%; cursor: pointer; position:absolute; right: 0;transform: translate(25%,-95%);"
          src="../assets/login/close_icon.png" @click="apply = false" alt="">
        <div style="text-align:center">
          <h2>尊敬的用户您好</h2>
          <p style="margin:10px">手机号将作为获取名额以及激励金的凭证，请谨慎填写</p>
        </div>
        <el-form :model="codeForm" :rules="codeRules" ref="codeForm" label-width="0px" class="demo-ruleForm"
          style="width: 90%;margin: 0 auto;margin-top: 20px;">
          <el-form-item prop="phone">
            <el-input v-model="codeForm.phone" placeholder="请输入手机号">
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input v-model="codeForm.code" placeholder="请输入验证码">
              <template #suffix>
                <img v-if="showCodeMsg" style="height:70%; cursor: pointer;" @click="getCode"
                  src="../assets/login/apply_code.png" alt="">
                <p v-if="!showCodeMsg">{{ count }}重新获取</p>
              </template>
            </el-input>
          </el-form-item>
          <div style="text-align: center;margin-top: 30px;">
            <img style="height:100%;width: 100%; cursor: pointer;" @click="codeLogin('codeForm')"
              src="../assets/login/apply_btn.png" alt="">
          </div>
        </el-form>
      </el-dialog>
    </div>
    <div class="success">
      <el-dialog :visible.sync="dialogVisible" width="80%" :show-close="false" :close-on-click-modal="false" top="25vh">
        <img
          style="width: 16%;height: 13%; cursor: pointer; position:absolute; right: 0;transform: translate(25%,-30%);"
          src="../assets/login/close_icon.png" @click="dialogVisible = false" alt="">
        <p style="color:#4d4d4d; font-size: 0.8rem; white-space:nowrap; position:absolute; top: 22%;left: 50%;transform: translate(-50%, 0);">
          您是第<span style="color:#de3a22;font-weight: bold;">{{ random }}</span>位获取激励金
        </p>
        <div @click="jump"
          style="width: 60%;height: 10%; cursor: pointer; position:absolute; top: 38%;left: 50%;transform: translate(-50%, 0);">
        </div>
        <img style="width: 30%; position:absolute; top: 72%;left: 50%;transform: translate(-50%, 0);"
          src="../assets/new_home/activ.png" alt="">
      </el-dialog>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      dialogVisible: false,
      apply: false,//申请弹窗
      showCodeMsg: true,
      timer: null,//定时器
      count: "",//读秒
      from: '33',//固定传
      codeForm: {
        phone: "",
        code: "",
      },
      codeRules: {
        phone: [{ validator: phoneRules, trigger: "blur" }],
        code: [{ required: true, message: "请输入短信验证码", trigger: "blur" }],
      },
    }
  },
  computed: {
    random() {
      return parseInt(Math.random() * (4999 - 1000) + 1000)
    }
  },
  mounted() { },
  methods: {
    addBtn() {
      this.apply = true
    },
    getCode() {
      this.$refs.codeForm.validateField("phone", (errorMsg) => {
        if (!errorMsg) {
          this.axios({
            method: "POST",
            url: "/loginController/getRCode",
            data: {
              phoneNum: this.codeForm.phone,
              checkFlag: "register",
              from: this.from
            }
          }).then(res => {
            if (res.data.status == 1) {
              const timcount = 60;
              if (!this.timer) {
                this.count = timcount;
                this.showCodeMsg = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= timcount) {
                    this.count--;
                  } else {
                    this.showCodeMsg = true;
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }, 1000)
              }
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          })
        }
      })
    },
    codeLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios({
            method: "POST",
            url: "/loginController/phoneRegister",
            data: {
              phoneNum: this.codeForm.phone,
              randCode: this.codeForm.code,
              from: "33",
              registSource: '2'
            },
          }).then((res) => {
            if (res.data.status >= 0) {
              this.$message({
                message: "获取激励名单成功",
                type: "success",
              });
              // window.sessionStorage.setItem("username", res.data.data.username);
              window.sessionStorage.setItem("userId", res.data.data.id);
              // window.sessionStorage.setItem("phoneNum", res.data.data.phoneNum);
              // this.$router.push("/home");
              this.apply = false
              this.dialogVisible = true
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    han() {
      window.open('https://www.haneton.com/')
    },
    wei() { 
      window.open('https://work.weixin.qq.com/kfid/kfcc7f894e85af548da')
    },
    jump() {
      this.$router.push('/selfHelp')
    },
  }

}
</script>

<style scoped>
.all {
  /* height: 100%; */
  width: 100%;
  position: relative;
}

::v-deep .success .el-dialog__body {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
}

::v-deep .el-dialog__header {
  display: none;
}

::v-deep .success .el-dialog {
  height: 50%;
  border-radius: 15px;
  background: url('../assets/login/envelope.png') no-repeat;
  background-size: cover;
  background-position: center;
}

::v-deep .apply .el-dialog {
  border-radius: 5px;
  background: url('../assets/login/apply_bc.png') no-repeat;
  background-size: cover;
}

::v-deep .el-input__suffix {
  display: flex;
}

::v-deep .el-input__suffix-inner {
  display: flex;
  align-items: center;
}
</style>